module.exports = __webpack_public_path__ + "img/technova.ab615e36.jpeg";